import React from 'react';
import { Button } from '../Forms/Forms';
import './PopIn.scss'
import useBodyClass from '../../custom-Hooks/useBodyClass';

const PopIn = ({ title, content, handlePrimaryButton, handleSecondaryButton, inverseButtons = false, titlePicto = {
    showTitlePicto: false, src: '', alt: ''
}, secondaryButtonLabel = "", primaryButtonLabel = "" }) => {
    useBodyClass('no-scroll')
    return (
        <div className='popin-overlay'>
            <div className='popin'>
                <h2 tabIndex='0' className='title'>{titlePicto.showTitlePicto && <img className='title-picto' src={titlePicto.src} alt={titlePicto.alt} />} {title}</h2>
                <div tabIndex='0'className="content">
                    {content}
                </div>
                <div className='row section-form'>
                    {primaryButtonLabel.length !== 0 && <Button type={inverseButtons ? 'button-bordred' : 'filled'} isDisabled={false}
                        handlClick={handlePrimaryButton}
                    >
                        {primaryButtonLabel}
                    </Button>}
                    {secondaryButtonLabel.length !== 0 && <Button type={inverseButtons ? 'filled' : 'button-bordred'} isDisabled={false}
                        handlClick={handleSecondaryButton}
                    >
                        {secondaryButtonLabel}
                    </Button>
                    }
                </div>
            </div>
        </div>
    )
}
export default PopIn;